module.exports = __webpack_public_path__ + "media/svg/logotipo-maxia-b009ebd8.svg";